var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup42(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 52,
    height: 52,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M52.066,41.365a6.463,6.463,0,0,1-.292,1.926l-2.485,7.991a1.083,1.083,0,1,1-2.069-.641L49.7,42.648a4.311,4.311,0,0,0-3.347-5.525l-8.716-1.582a1.084,1.084,0,0,1-.891-1.066V21.839a1.831,1.831,0,0,0-3.66,0V44.182a1.083,1.083,0,0,1-1.848.767L27.2,40.908a1.969,1.969,0,1,0-2.784,2.784l6.5,6.5a1.084,1.084,0,1,1-1.532,1.534l-6.5-6.5a4.137,4.137,0,0,1,5.85-5.85l2.188,2.188V21.848a4,4,0,0,1,7.993,0V33.58L46.747,35a6.478,6.478,0,0,1,5.319,6.366m-21.909-27a1.084,1.084,0,0,0-1.532,0L18.394,24.6l-4.767-4.767A1.083,1.083,0,1,0,12.1,21.36L17.638,26.9a1.082,1.082,0,0,0,1.531,0l11-11a1.084,1.084,0,0,0-.011-1.543m-14.116,24.1A18.417,18.417,0,1,1,38.2,15.023a1.084,1.084,0,1,0,2.065-.661A20.583,20.583,0,1,0,15.5,40.561a1.061,1.061,0,0,0,.271.035,1.083,1.083,0,0,0,.271-2.134",
    transform: "translate(-0.066 -0.044)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup42);
export default __webpack_public_path__ + "static/media/Group42.577edd7d9c316063a9aa4ebc7cf3a265.svg";
export { ForwardRef as ReactComponent };